import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import { AppShell } from "./components/AppShell";
import "./App.css";

import LoginPage from "./pages/LoginPage";
import RegisterWizardPage from "./pages/RegisterWizardPage";
import DashboardPage from "./pages/DashboardPage";
import IssuesListPage from "./pages/IssuesListPage";
import IssueCreatePage from "./pages/IssueCreatePage";
import IssueDetailPage from "./pages/IssueDetailPage";
import MeetingsPage from "./pages/MeetingsPage";
import MeetingDetailPage from "./pages/MeetingDetailPage";
import ActionsPage from "./pages/ActionsPage";
import NoticesPage from "./pages/NoticesPage";
import DirectoryPage from "./pages/DirectoryPage";
import SearchPage from "./pages/SearchPage";
import StaffHomePage from "./pages/StaffHomePage";
import ProfilePage from "./pages/ProfilePage";
import SettingsPage from "./pages/SettingsPage";
import VendorsPage from "./pages/VendorsPage";
import DocumentsPage from "./pages/DocumentsPage";
import SuperAdminPage from "./pages/SuperAdminPage";
import RequestDemoPage from "./pages/RequestDemoPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import DuesPreviewPage from "./pages/dues/DuesPreviewPage";
import ChangePasswordGate from "./components/ChangePasswordGate";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-stone-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <ChangePasswordGate>{children}</ChangePasswordGate>;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-stone-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "super_admin") return <Navigate to="/super-admin" replace />;
  if (!user.community_id) return <Navigate to="/register" replace />;
  if (user.role === "staff") return <Navigate to="/staff" replace />;
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterWizardPage />} />
          <Route path="/request-demo" element={<RequestDemoPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/staff" element={<Protected><StaffHomePage /></Protected>} />
          <Route path="/super-admin" element={<Protected><SuperAdminPage /></Protected>} />
          <Route path="/" element={<HomeRedirect />} />
          <Route path="*" element={
            <Protected>
              <AppShell>
                <Routes>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/issues" element={<IssuesListPage />} />
                  <Route path="/issues/new" element={<IssueCreatePage />} />
                  <Route path="/issues/:id" element={<IssueDetailPage />} />
                  <Route path="/meetings" element={<MeetingsPage />} />
                  <Route path="/meetings/:id" element={<MeetingDetailPage />} />
                  <Route path="/actions" element={<ActionsPage />} />
                  <Route path="/todos" element={<ActionsPage />} />
                  <Route path="/notices" element={<NoticesPage />} />
                  <Route path="/directory" element={<DirectoryPage />} />
                  <Route path="/vendors" element={<VendorsPage />} />
                  <Route path="/documents" element={<DocumentsPage />} />
                  <Route path="/dues" element={<DuesPreviewPage />} />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </AppShell>
            </Protected>
          } />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;